import aiKnowledge from './chidren-pages/aiKnowledge';
import aiServant from './chidren-pages/aiServant';
import experience from './chidren-pages/experience';
import experiment from './chidren-pages/experiment';
import insight from './chidren-pages/insight';
import operate from './chidren-pages/operate';
import operationMgt from './chidren-pages/operationMgt';
import smartConstruction from './chidren-pages/smartConstruction';
import system from './chidren-pages/system';
import root from './root';

export default [
  ...root,
  ...operate,
  ...system,
  ...aiServant,
  ...smartConstruction,
  ...insight,
  ...experiment,
  ...aiKnowledge,
  ...experience,
  ...operationMgt,
];
